const news = [
  {
    id: 1,
    title: "برنامج كسوة شتاء لجمعية التنمية الأهلية بجزيرة بدارين",
    description: `قامت جمعية التنمية الأهلية بتنظيم برنامج "كسوة الشتاء" لدعم الأسر المحتاجة في جزيرة بدارين، وذلك في إطار تعزيز المسؤولية الاجتماعية المجتمعية. يهدف البرنامج إلى رفع جودة ونوعية الجهود والمبادرات التطوعية المستدامة، من خلال توفير الملابس الشتوية الضرورية للمستفيدين.
وأكدت الجمعية على أهمية التعاون المشترك بين المؤسسات المجتمعية والقطاع الخاص لتحقيق أهداف إنسانية واجتماعية تسهم في تحسين مستوى المعيشة للأسر المستفيدة. وتأتي هذه المبادرة كجزء من التزام الجمعية بتعزيز التكافل الاجتماعي ودعم الفئات الأكثر احتياجاً خلال فصل الشتاء.`,
    imageUrl: `/images/news/post-1/4c528794-e98a-4242-b1c0-44b272ea29b1.JPG`,
    imageDescription: ``,
    date_posted: `December 2024 23`,
    images: [
      `/images/news/post-1/4c528794-e98a-4242-b1c0-44b272ea29b1.JPG`,
      `/images/news/post-1/64c59b74-86e2-4e52-9832-198c55a996a8.JPG`,
      `/images/news/post-1/a9a721d6-50ce-4b8b-aff1-247e341285e4.JPG`,
      `/images/news/post-1/a9679d4d-b824-4796-ba71-eea9e2bf9428.JPG`,
      `/images/news/post-1/af0b69af-0c2c-42b9-bdcb-ca84dd357b9f.JPG`,
      `/images/news/post-1/d9f1f087-4c41-4088-acf9-9e1e216921a8.JPG`,
      `/images/news/post-1/de773107-8681-418b-8106-8789b504f1d4.JPG`,
      `/images/news/post-1/e428dee8-a492-4c4d-af67-c9565482b7f4.JPG`,
      `/images/news/post-1/e8820f58-ee12-4b94-aa3d-e16cbf78ab1e.MP4`,
      `/images/news/post-1/fb5b54b5-470e-4128-8cb2-1f090a277f85.MP4`,
    ],
  },
  {
    id: 2,
    title: `برنامج ثمار الموهبة "بادر" لدعم الطلاب الموهوبين`,
    description: `قامت جمعية التنمية الأهلية بتنفيذ برنامج "ثمار الموهبة بادر"، الذي يهدف إلى اكتشاف وتنمية قدرات الطلاب لتمكينهم من المشاركة الفاعلة في المسابقات المحلية والدولية. يركز البرنامج على تطوير المهارات الأكاديمية والإبداعية لدى الطلاب من خلال ورش عمل متخصصة، دورات تدريبية، وأنشطة تحفيزية متنوعة.
يسعى البرنامج إلى توفير بيئة محفزة تشجع الطلاب على التفوق والابتكار، كما يتيح لهم الفرصة للتفاعل مع خبراء وموجهين في مختلف المجالات. من خلال هذه المبادرة، تلتزم الجمعية بدعم الجيل الناشئ وتعزيز دورهم في المجتمع، مما يسهم في إعداد قادة مستقبليين قادرين على المنافسة والتميز على الصعيدين المحلي والدولي.
تقوم الجمعية بتنفيذ البرنامج بالتعاون مع مؤسسات تعليمية وشركاء مجتمعيين، مؤكدةً على أهمية الاستثمار في طاقات الشباب لتحقيق التنمية المستدامة وبناء مستقبل مشرق للمجتمع.`,
    imageUrl: `/images/news/post-2/PHOTO-2024-12-16-12-40-55.jpg`,
    imageDescription: ``,
    date_posted: `December 2024 23`,
    images: [
      `/images/news/post-2/PHOTO-2024-12-16-12-40-46 2.jpg`,
      `/images/news/post-2/PHOTO-2024-12-16-12-40-46.jpg`,
      `/images/news/post-2/PHOTO-2024-12-16-12-40-55.jpg`,
    ],
  },
];

export { news };
